import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { BubbleMenu } from '@tiptap/react';
import { TextFormattingMenu } from '../../components/TextBubbleMenu';
import { useComposer } from '../../hooks/useComposer';
export const TextFormattingBubbleMenu = ({ editor }) => {
    const { state } = useComposer();
    return (_jsx(_Fragment, { children: _jsx(BubbleMenu, { pluginKey: "text-bubble-menu", shouldShow: ({ editor, from, to }) => {
                return (Math.abs(to - from) > 0 &&
                    !editor.isActive('async-image') &&
                    !editor.isActive('video') &&
                    !editor.isActive('embed') &&
                    !editor.isActive('attachment') &&
                    !editor.isActive('custom-link'));
            }, editor: editor, tippyOptions: { maxWidth: 624 }, children: !state.textFormatMenu && (_jsx(TextFormattingMenu, { editor: editor, className: "hidden sm:flex" }, void 0)) }, void 0) }, void 0));
};
//# sourceMappingURL=text.js.map